var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rp-permissions',{attrs:{"requireOne":['read_surgeons']}},[(_vm.show)?_c('div',{staticClass:"sidebar-links"},[_c('router-link',{class:{active: _vm.isAllSurgeons},attrs:{"to":"/surgeons"}},[_vm._v("All surgeons")])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32770347","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideNav/SurgeonsLinks.vue
// module id = null
// module chunks = 